import { useEffect } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { MainStore, useMainActions } from '../store';
import { updateUTMCampaign, usePageEvents } from './tracking';

const useMainState = createStateSelectorHook(MainStore, ['projectData']);

export const useTrackViewedProject = () => {
  const { projectData } = useMainState();
  const mainActions = useMainActions();
  const { trackDocumentViewed } = usePageEvents();

  useEffect(() => {
    // We want to update UTM value only when user actually got loaded project data
    if (!projectData) {
      return;
    }

    trackDocumentViewed();
    updateUTMCampaign({
      utmCampaign: 'shared_document_view',
      shareDocumentId: mainActions.getShareDocumentId(),
    });
  }, [projectData, mainActions, trackDocumentViewed]);
};
